import { LayersPanel } from './panels/LayersPanel';
import { InspectorPanel } from './panels/InspectorPanel';
import { ColorPanel } from './panels/ColorPanel';
import { SectionId } from './sections';

/**
 * The right column.
 *
 * Deliberately narrow and fixed: colour, layers and the cell inspector are
 * needed in every section, so they live here instead of being duplicated into
 * each one. Everything else belongs to the section panel on the left.
 */
export function RightPanel({
  collapsed,
  section,
}: {
  collapsed: boolean;
  section: SectionId;
}): JSX.Element {
  return (
    <aside className={`sidebar-right${collapsed ? ' collapsed' : ''}`}>
      <div className="side-body">
        {/* The Colour section owns the picker while it is open; showing it
            twice side by side would just be noise. */}
        {section === 'color' ? null : <ColorPanel />}
        <LayersPanel />
        <InspectorPanel />
      </div>
    </aside>
  );
}
